/**
 * Accessible quantity steppers.
 */

export function initQuantity() {
	document.addEventListener('click', (e) => {
		const decrease = e.target.closest('[data-qty-decrease]');
		const increase = e.target.closest('[data-qty-increase]');

		if (!decrease && !increase) {
			return;
		}

		const wrapper = e.target.closest('.dc-quantity, .quantity');
		const input = wrapper?.querySelector('input.qty, input[type="number"]');

		if (!input) {
			return;
		}

		const min = parseInt(input.min || '1', 10);
		const max = input.max ? parseInt(input.max, 10) : Infinity;
		let value = parseInt(input.value || '1', 10);

		if (increase) {
			value = Math.min(value + 1, max);
		} else {
			value = Math.max(value - 1, min);
		}

		input.value = String(value);
		input.dispatchEvent(new Event('change', { bubbles: true }));
	});

	document.querySelectorAll('.quantity:not(.dc-quantity)').forEach((el) => {
		if (el.querySelector('[data-qty-decrease]')) {
			return;
		}

		el.classList.add('dc-quantity');
		const input = el.querySelector('input.qty, input[type="number"]');
		if (!input) {
			return;
		}

		const dec = document.createElement('button');
		dec.type = 'button';
		dec.dataset.qtyDecrease = '';
		dec.setAttribute('aria-label', 'Decrease quantity');
		dec.textContent = '−';

		const inc = document.createElement('button');
		inc.type = 'button';
		inc.dataset.qtyIncrease = '';
		inc.setAttribute('aria-label', 'Increase quantity');
		inc.textContent = '+';

		el.insertBefore(dec, input);
		el.appendChild(inc);
	});
}
